import React from "react";
import Button from "@mui/material/Button";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()({
  root: {
    borderRadius: 20,
    fontSize: 12,
    width: "auto",
    textTransform: "capitalize",
  },
});

const ButtonUI = (props) => {
  const { classes } = useStyles();

  return <Button classes={{ root: classes.root }} {...props} />;
};

export default ButtonUI;
